import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';

/**
 * Interfaces
 */
import { AppHttpUtils, IResponse } from '@network';
import { IDataTableRequest, IDataTableResponse } from './interfaces';

/**
 * models
 */
import { IDataTableResponseModel } from './models/interfaces';
import { DataTableResponseModel } from './models/data-table-response-model';

@Injectable()
export class DataTableSourceService {

  /**
   *
   */
  private readonly _httpContext = new HttpContext();

  /**
   * Constructor
   * @param _http - HttpClient
   */
  constructor(private _http: HttpClient) {

    // set the http context
    AppHttpUtils.withBypassToast(this._httpContext);

  }

  /**
   * Data table source handler
   *
   * Unwraps the standard `IResponse` envelope and wraps the datatable payload
   * in {@link DataTableResponseModel}, so callers read camelCase counts with
   * safe fallbacks instead of the raw snake_case wire fields.
   *
   * @param endpoint - The endpoint of the data table source
   * @param bodyRequest - The body request
   * @returns Observable<IDataTableResponseModel<TData>>
   */
  public dataTableSourceHandler<TData>(endpoint: string, bodyRequest: IDataTableRequest, options: Record<string, any> = {}): Observable<IDataTableResponseModel<TData>> {

    // set the http context
    options['context'] = this._httpContext;

    return this._http
                .post<IResponse<IDataTableResponse<TData>>>(endpoint, bodyRequest, options)
                .pipe(
                  map((response) => new DataTableResponseModel<TData>(response?.data)),
                )
  }

}